import {useUserPreferencesStore} from '../store/userPreferences';

export const getUserPreference = <Bool extends boolean = false>(
	key: string,
	asBoolean?: Bool,
) => useUserPreferencesStore.getState().get<Bool>(key, asBoolean); // as Bool extends true ? boolean : string | undefined;

// TODO: rename all instances of getPreference to getUserPreference
export const getPreference = getUserPreference;

// export default getUserPreference;
